import React, { useEffect, useState } from 'react';
import apiClient from '../../services/api'; // Adjust path if needed
import { Category } from '../../types'; // Adjust path if needed
import CategoryManager from '../../components/goal_planner/CategoryManager'; // Adjust path if needed

const CategoriesPage: React.FC = () => {
  const [categories, setCategories] = useState<Category[]>([]);
  const [isLoading, setIsLoading] = useState<boolean>(true);
  const [error, setError] = useState<string | null>(null);

  const fetchData = async () => {
    setIsLoading(true);
    setError(null);
    try {
      // Fetch Categories
      const catRes = await apiClient.get('/goals/categories/');
      setCategories(catRes.data);
      console.log("Fetched Categories:", catRes.data);
    } catch (err: any) {
      console.error("Failed to fetch categories page data:", err);
      setError(err.message || 'Failed to load categories data.');
    } finally {
      setIsLoading(false);
    }
  };

  useEffect(() => {
    fetchData();
  }, []);

  const refetchCategories = async () => {
      await fetchData();
  };

  return (
    <div className="container mx-auto p-4 md:p-6 space-y-6">
      {/* Loading State */} 
      {isLoading && (
        <div className="flex items-center justify-center h-64">
          <div className="animate-spin rounded-full h-12 w-12 border-t-2 border-b-2 border-primary"></div>
          <span className="ml-4 text-muted-foreground">Loading categories...</span>
        </div>
      )}
      
      {/* Error State */} 
      {error && (
        <div className="bg-destructive/10 text-destructive p-4 rounded-md border border-destructive/30">
          <p><strong>Error:</strong> {error}</p>
        </div>
      )}

      {!isLoading && !error && (
        <div className="space-y-4 md:space-y-6">
          <h1 className="text-xl md:text-2xl font-semibold">Categories</h1>
           <CategoryManager 
               categories={categories} 
               refreshCategories={refetchCategories} 
           />
        </div>
      )}
    </div>
  );
};

export default CategoriesPage; 